/** @jsxRuntime classic */

export default function TicketButton({ ...rest }) {
  // Shadowed by gatsby-theme-cms
  return null;
}
